import React, { useState, useEffect } from "react";
import T from "./TheTool";
import Timer from "./TheTimer";
import GUIset_TextArea from "./gui/GUIset_TextArea";
import Template from "./TheTemplate";

const EditDistance = () => {
	useEffect(() => {
		document.title = "Levenshtein Distance (String Edit Distance)";
	}, []);

	const [guiTxtArea, guiTxtAreaChange] = useState(
		"GEEK,GESEK\nBATMAN,BADMAN\nBAMAN,BATMA"
	);
	//----
	const [partResult, partResultChange] = useState(<div></div>); //bottom part that show result

	const buttonClick1 = () => {
		if (guiTxtArea != "") {
			process_bulk();
			BuildResult();
		}
	};

	var txt_result = "";

	function process_bulk() {
		var cases = guiTxtArea.split("\n");
		// console.log("ccc " + cases.length + " ____ " + cases);
		txt_result = "";
		for (var c = 0; c < cases.length; c++) {
			if (c > 0) {
				txt_result += "\n";
			}
			txt_result += "\nCase #" + c;
			process(cases[c]);
		}
	}

	function process(str) {
		var arr = str.split(",");
		if (arr.length > 1) {
			Timer.start();
			var d = editDistDP(arr[0], arr[1], arr[0].length, arr[1].length);
			var txt_time = Timer.stop_print();
			//--------------------------
			console.log(txt_time);
			txt_result += ": Distance " + d + " : " + str;
			txt_result += "\n" + txt_time;
		}
	}

	// int editDistDP(String str1, String str2, int m, int n)
	function editDistDP(str1, str2, m, n) {
		// var dp = T.getMatrix_empty(m+1, n+1); // var dp[][] = new int[m+1][n+1];
		var dp = T.getMatrix(m + 1, n + 1, 0); // var dp[][] = new int[m+1][n+1];
		// Fill d[][] in bottom up manner
		for (var i = 0; i <= m; i++) {
			for (var j = 0; j <= n; j++) {
				// first string is empty, insert all characters of second to the first string
				if (i == 0) {
					dp[i][j] = j;
				}
				// second string is empty, remove all characters of first string
				else if (j == 0) {
					dp[i][j] = i;
				}
				// same last characters, recur for remaining string
				else if (str1.charAt(i - 1) == str2.charAt(j - 1)) {
					dp[i][j] = dp[i - 1][j - 1];
				}
				// different last character, consider all
				else {
					dp[i][j] =
						1 +
						min(
							dp[i][j - 1], // Insert
							dp[i - 1][j], // Remove
							dp[i - 1][j - 1]
						); // Replace
				}
				// console.log("dp[i][j] " + dp[i][j]);
			}
		}
		return dp[m][n];
	}

	// static int min(int x,int y,int z)
	function min(x, y, z) {
		if (x <= y && x <= z) return x;
		if (y <= x && y <= z) return y;
		else return z;
	}

	//-------------------------

	function BuildResult() {
		partResultChange(Template.simple01("key1", "Result", txt_result, 22, 22));
	}
	return (
		<GUIset_TextArea
			title="Edit Distance (Levenshtein Distance)"
			desc="Quantifying how dissimilar two strings (e.g., words) are to one another."
			label1="Cases"
			label2="each line: string1,string2"
			guiTxtArea={guiTxtArea}
			guiTxtAreaChange={guiTxtAreaChange}
			buttonClick={buttonClick1}
			partResult={partResult}
		/>
	);
};

export default EditDistance;



// import GUI_Header from "./gui/GUI_Header";
// import GUI_InputTextSingle from "./gui/GUI_InputTextSingle";
// import GUI_Credit from "./gui/GUI_Credit";
// import GUI_InputTextArea from "./gui/GUI_InputTextArea";



		// partResultChange(
		// 	<div>
		// 		<div style={{ whiteSpace: "pre-line", fontSize: 22 }}>
		// 			<h2>Result</h2>
		// 		</div>
		// 		<div style={{ whiteSpace: "pre-line", fontSize: 22 }}>{txt_result}</div>
		// 	</div>
		// );




		
		// <div className="todoapp stack-large">
		// 	<GUI_Header
		// 		title={"Edit Distance (Levenshtein Distance)"}
		// 		desc={
		// 			"Quantifying how dissimilar two strings (e.g., words) are to one another."
		// 		}
		// 	/>
		// 	<div style={{ marginTop: "3em" }}> </div>

		// 	<GUI_InputTextArea
		// 		id="inputItemList"
		// 		className="textarea_001"
		// 		placeholder={"name,size,value"}
		// 		// placeholder={"name,weight,value\nname,weight,value\nname,weight,value"}
		// 		// style={{ minHeight: "308px", whiteSpace: "pre-line" , fontSize: 28  }}
		// 		style={{ minHeight: "308px", whiteSpace: "pre-line" }}
		// 		// defaultValue={txtDefault}
		// 		// defaultValue="A,12,4B,4,10 C,2,2 D,1,2 E,1,1"
		// 		// value={guiTxtArea}
		// 		// onChange={guiTxtAreaChange}
		// 		area1Change={guiTxtAreaChange}
		// 		text1={guiTxtArea}
		// 		label={"Cases"}
		// 		label2={"each line: string1,string2"}
		// 	/>

		// 	<div style={{ display: "flex", marginLeft: '3%', marginRight: '3%' }}>
		// 		<button
		// 			onClick={() => buttonClick1()}
		// 			className="btn btn__primary btn__lg"
		// 			style={{ flex: 1, height: 50 }}
		// 		>
		// 			Calculate
		// 		</button>
		// 	</div>
		// 	<div style={{ marginTop: "3em" }}> </div>
		// 	{partResult}
		// 	<GUI_Credit />
		// </div>
